import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  Menu,
  Accordion,
  Icon,
  Dropdown,
  Grid,
  Popup,
  Tab,
  TextArea,
  Button
} from 'semantic-ui-react';
import _ from 'lodash';
import { toast } from 'react-toastify';
import shortid from 'short-id';
import { bindActionCreators } from 'redux';

import {
  getCanvas,
  updateCanvasVideo,
  duplicateCanvas,
  launchCanvas
} from '../../../fbApi/Canvas';
import { updateAdParameters } from '../../../fbApi/Ad';
import { updateAdLineage } from '../../../utils/ad.lineage';
import * as AppActions from '../../../actions';
import AdNotesQC from './AdNotesQC';
import AssetGallery from '../../../components/common/AssetGalleryV2/AssetGallery';
import { getS3Bucket } from '../../../containers/Domains';
import { renderPopupQCOrCheckbox } from '../../../utils/ad.common';
import './AdMoreInfo.css';

const s3BucketUrl = getS3Bucket();

class AdMoreInfo extends PureComponent {
  constructor(props) {
    super(props);
    let ad = props.ad;
    if (
      ad.lineageInfo.isOrganic === undefined ||
      ad.lineageInfo.isOrganic === null
    ) {
      ad = {
        ...ad,
        lineageInfo: {
          ...ad.lineageInfo,
          isOrganic: false
        }
      };
    }
    if (
      ad.lineageInfo.clientRq === undefined ||
      ad.lineageInfo.clientRq === null
    ) {
      ad = {
        ...ad,
        lineageInfo: {
          ...ad.lineageInfo,
          clientRq: false
        }
      };
    }
    this.state = {
      stateAd: ad,
      prevStateAd: ad,
      facebookEdit: false,
      vehiclesEdit: false,
      targetEdit: false,
      clientRQEdit: false,
      buildEdit: false,
      qcEdit: false,
      coopEdit: false,
      editMode: props.editMode,
      savingFacebook: false
    };
  }
  componentDidMount() {
    this.props.actions.adComparerAdMoreInfoIndex(5, this.props.parentAdId);
  }

  getAssetType = (adObjective) => {
    if (adObjective && adObjective.link_data) {
      return 'image';
    } else if (adObjective && adObjective.video_data) {
      return 'video';
    }
    return '';
  };
  getAssetPreview = (adObjective) => {
    if (adObjective && adObjective.link_data) {
      return adObjective.link_data.image_url;
    } else if (adObjective && adObjective.video_data) {
      return adObjective.video_data.video_id;
    }
    return '';
  };

  getAssetCarouselPreview = (objectiveData) => {
    if (objectiveData && objectiveData.video_id) {
      return objectiveData.video_id;
    }
    return objectiveData.image_url;
  };

  handleSave = async () => {
    const { stateAd } = this.state;
    const lineageToUpdate = _.omit(stateAd.lineageInfo, ['adId', '__typename']);
    lineageToUpdate.modefiedBy = this.props.user.email;
    lineageToUpdate.modifiedDate = new Date();
    await updateAdLineage(lineageToUpdate, stateAd.lineageInfo.adId);
    this.props.updateCompareAd(stateAd);
    this.setState({ prevStateAd: stateAd });
    toast('Lineage Fields Successfully Saved!', {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 2000,
      type: toast.TYPE.SUCCESS,
      hideProgressBar: true
    });
  };
  handleFacebookSave = async () => {
    const { stateAd } = this.state;
    const { getFbToken, updatePreview, updateCompareAd } = this.props;
    const token = getFbToken();
    const adDataUpdate = {
      id: stateAd.ad_id
    };

    try {
      if (stateAd.adObjective) {
        const objectStorySpec = stateAd.adObjective;
        if (objectStorySpec) {
          if (objectStorySpec.link_data) {
            if (
              objectStorySpec.link_data &&
              objectStorySpec.link_data.child_attachments &&
              objectStorySpec.link_data.child_attachments.length
            ) {
              objectStorySpec.link_data.child_attachments = objectStorySpec.link_data.child_attachments.map(
                (ca) => {
                  if (ca.image_hash && ca.picture) {
                    return _.omit(ca, ['image_hash']);
                  }
                  if (ca.image_hash && ca.image_url) {
                    return _.omit(ca, ['image_hash']);
                  }
                  return ca;
                }
              );
            }
            objectStorySpec.link_data.message = stateAd.facebookInfo.ad_body;
            if (!stateAd.isCarousel) {
              objectStorySpec.link_data.description = stateAd.facebookInfo
                .description
                ? stateAd.facebookInfo.description
                : '';
              objectStorySpec.link_data.name = stateAd.facebookInfo.ad_title;
              objectStorySpec.link_data.link = stateAd.facebookInfo.ad_link;
              objectStorySpec.link_data.call_to_action.type =
                stateAd.facebookInfo.callToActionType;
            }
            if (
              objectStorySpec.link_data.image_hash &&
              objectStorySpec.link_data.picture
            ) {
              objectStorySpec.link_data = _.omit(objectStorySpec.link_data, [
                'image_hash'
              ]);
            }
            if (
              objectStorySpec.link_data.image_hash &&
              objectStorySpec.link_data.image_url
            ) {
              objectStorySpec.link_data = _.omit(objectStorySpec.link_data, [
                'image_hash'
              ]);
            }
            if (
              objectStorySpec.link_data.call_to_action &&
              objectStorySpec.link_data.call_to_action.value &&
              objectStorySpec.link_data.call_to_action.value.link
            ) {
              objectStorySpec.link_data.call_to_action.value.link =
                stateAd.facebookInfo.ad_link;
              objectStorySpec.link_data.call_to_action.value.link_caption =
                stateAd.facebookInfo.linkCaption;
            }
          } else if (objectStorySpec.template_data) {
            objectStorySpec.template_data.message =
              stateAd.facebookInfo.ad_title;
            objectStorySpec.template_data.description =
              stateAd.facebookInfo.ad_body;
            objectStorySpec.template_data.link = stateAd.facebookInfo.ad_link;
            objectStorySpec.template_data.description =
              stateAd.facebookInfo.description;
            objectStorySpec.template_data.call_to_action.type =
              stateAd.facebookInfo.callToActionType;
            if (
              objectStorySpec.template_data.image_hash &&
              objectStorySpec.template_data.picture
            ) {
              objectStorySpec.template_data = _.omit(
                objectStorySpec.template_data,
                ['image_hash']
              );
            }
            if (
              objectStorySpec.template_data.image_hash &&
              objectStorySpec.template_data.image_url
            ) {
              objectStorySpec.template_data = _.omit(
                objectStorySpec.template_data,
                ['image_hash']
              );
            }
            if (
              objectStorySpec.template_data.call_to_action &&
              objectStorySpec.template_data.call_to_action.value &&
              objectStorySpec.template_data.call_to_action.value.link
            ) {
              objectStorySpec.template_data.call_to_action.value.link =
                stateAd.facebookInfo.ad_link;
              objectStorySpec.template_data.call_to_action.value.link_caption =
                stateAd.facebookInfo.linkCaption;
            }
          } else if (objectStorySpec.video_data) {
            if (stateAd.isCanvas) {
              const canvasLink = stateAd.facebookInfo.ad_link;
              const canvasId = canvasLink.replace(
                'https://fb.com/canvas_doc/',
                ''
              );
              const currentFullCanvas = await getCanvas(canvasId, token);
              const canvasDup = await duplicateCanvas(
                canvasId,
                currentFullCanvas.owner.access_token
              );
              const canvasFull = await getCanvas(canvasDup.id, token);
              const videoElement = canvasFull.body_elements.find(
                (be) => be.element_type === 'VIDEO'
              );
              await updateCanvasVideo(
                videoElement.id,
                objectStorySpec.video_data.video_id,
                canvasFull.owner.access_token
              );
              await launchCanvas(canvasDup.id, canvasFull.owner.access_token);
              if (
                objectStorySpec.video_data.call_to_action &&
                objectStorySpec.video_data.call_to_action.value &&
                objectStorySpec.video_data.call_to_action.value.link
              ) {
                objectStorySpec.video_data.call_to_action.value.link = `https://fb.com/canvas_doc/${canvasDup.id}`;
                stateAd.facebookInfo.ad_link = `https://fb.com/canvas_doc/${canvasDup.id}`;
                stateAd.canvas_name = canvasFull;
              }
            } else if (
              objectStorySpec.video_data.call_to_action &&
              objectStorySpec.video_data.call_to_action.value &&
              objectStorySpec.video_data.call_to_action.value.link
            ) {
              objectStorySpec.video_data.call_to_action.value.link =
                stateAd.facebookInfo.ad_link;
              objectStorySpec.video_data.call_to_action.value.link_caption =
                stateAd.facebookInfo.linkCaption;
            }

            objectStorySpec.video_data.title = stateAd.facebookInfo.ad_title;
            objectStorySpec.video_data.message = stateAd.facebookInfo.ad_body;
            objectStorySpec.video_data.link_description = stateAd.facebookInfo
              .description
              ? stateAd.facebookInfo.description
              : '';
            objectStorySpec.video_data.call_to_action.type =
              stateAd.facebookInfo.callToActionType;
            if (
              objectStorySpec.video_data.image_hash &&
              objectStorySpec.video_data.picture
            ) {
              objectStorySpec.video_data = _.omit(objectStorySpec.video_data, [
                'image_hash'
              ]);
            }
            if (
              objectStorySpec.video_data.image_hash &&
              objectStorySpec.video_data.image_url
            ) {
              objectStorySpec.video_data = _.omit(objectStorySpec.video_data, [
                'image_hash'
              ]);
            }
          }
        }
        adDataUpdate.creative = objectStorySpec;
        adDataUpdate.degrees_of_freedom_spec = 
        {
          creative_features_spec: {
            standard_enhancements: {
              enroll_status: 'OPT_OUT'
            }
          }
        };
        adDataUpdate.url_tags = stateAd.url_tags;

        const result = await updateAdParameters(adDataUpdate, token);
        const json = await result.json();
        
        if (json.error) {
          toast(`Facebook Error: ${json.error.error_user_msg}.`, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 6000,
            type: toast.TYPE.ERROR,
            hideProgressBar: true
          });
        } else {
          stateAd.creative = { object_story_spec: objectStorySpec };
          stateAd.adObjective = objectStorySpec;
          updatePreview(stateAd);
          updateCompareAd(stateAd);
          toast('Facebook Successfully Saved!', {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            type: toast.TYPE.SUCCESS,
            hideProgressBar: true
          });
        }
      }
    } catch (e) {
      toast('Facebook Error: Fail updating canvas ad.', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 6000,
        type: toast.TYPE.ERROR,
        hideProgressBar: true
      });
    } finally {
      this.setState((prevState) => ({
        ...prevState,
        savingFacebook: false,
        prevStateAd: stateAd
      }));
    }
  };
  compareInfo = (source, target, editMode) => {
    if (editMode) {
      return '';
    }
    if (
      (typeof source === 'undefined' && typeof target === 'undefined') ||
      (source === null && target === null)
    ) {
      return '';
    } else if (
      typeof source === 'undefined' ||
      typeof target === 'undefined' ||
      source === null ||
      target === null
    ) {
      return 'yellow';
    }
    return source.toString().trim() === target.toString().trim()
      ? ''
      : 'yellow';
  };

  handleAccordionClick = (index) => {
    const { moreInfoIndex, parentAdId } = this.props;
    if (moreInfoIndex[parentAdId] === index) {
      this.props.actions.adComparerAdMoreInfoIndex(-1, parentAdId);
    } else {
      this.props.actions.adComparerAdMoreInfoIndex(index, parentAdId);
    }
    this.setState({
      facebookEdit: false,
      vehiclesEdit: false,
      targetEdit: false,
      clientRQEdit: false,
      buildEdit: false,
      coopEdit: false
    });
  };

  handleFieldUpdate = (field, value) => {
    const { stateAd } = this.state;
    const newAd = {
      ...stateAd,
      lineageInfo: {
        ...stateAd.lineageInfo,
        [field]: value
      }
    };
    this.setState({ stateAd: newAd });
  };
  handleAdFieldUpdate = (field, value) => {
    const { stateAd } = this.state;
    const newAd = {
      ...stateAd,
      [field]: value
    };
    this.setState({ stateAd: newAd });
  };
  handleFacebookFieldUpdateCarousel = (field, value, index) => {
    const { stateAd } = this.state;
    if (field === 'call_to_action') {
      stateAd.adObjective.link_data.child_attachments[index][
        field
      ].type = value;
    } else {
      stateAd.adObjective.link_data.child_attachments[index][field] = value;
    }
    this.setState({ stateAd });
  };
  handleFacebookFieldUpdate = (field, value) => {
    const { stateAd } = this.state;
    const newAd = {
      ...stateAd,
      facebookInfo: {
        ...stateAd.facebookInfo,
        [field]: value
      }
    };
    this.setState({ stateAd: newAd });
  };
  updateFacebookPreview = () => {
    const { stateAd } = this.state;
    const newAd = stateAd;
    const objectStorySpec = stateAd.adObjective;

    if (objectStorySpec) {
      if (objectStorySpec.link_data) {
        if (
          objectStorySpec.link_data &&
          objectStorySpec.link_data.child_attachments &&
          objectStorySpec.link_data.child_attachments.length
        ) {
          objectStorySpec.link_data.child_attachments = objectStorySpec.link_data.child_attachments.map(
            (ca) => {
              if (ca.image_hash && ca.picture) {
                return _.omit(ca, ['image_hash']);
              }
              if (ca.image_hash && ca.image_url) {
                return _.omit(ca, ['image_hash']);
              }
              return ca;
            }
          );
        }
        if (!newAd.isCarousel) {
          objectStorySpec.link_data.description = newAd.facebookInfo.description
            ? newAd.facebookInfo.description
            : '';
          objectStorySpec.link_data.link = newAd.facebookInfo.ad_link;
          objectStorySpec.link_data.name = newAd.facebookInfo.ad_title;
          objectStorySpec.link_data.call_to_action.type =
            newAd.facebookInfo.callToActionType;
        }
        objectStorySpec.link_data.message = newAd.facebookInfo.ad_body;
        if (
          objectStorySpec.link_data.image_hash &&
          objectStorySpec.link_data.image_url
        ) {
          objectStorySpec.link_data = _.omit(objectStorySpec.link_data, [
            'image_hash'
          ]);
        }
        if (
          objectStorySpec.link_data.call_to_action &&
          objectStorySpec.link_data.call_to_action.value &&
          objectStorySpec.link_data.call_to_action.value.link
        ) {
          objectStorySpec.link_data.call_to_action.value.link =
            newAd.facebookInfo.ad_link;
          objectStorySpec.link_data.call_to_action.value.link_caption =
            newAd.facebookInfo.linkCaption;
        }
      } else if (objectStorySpec.template_data) {
        objectStorySpec.template_data.message = newAd.facebookInfo.ad_title;
        objectStorySpec.template_data.description = newAd.facebookInfo.ad_body;
        objectStorySpec.template_data.link = newAd.facebookInfo.ad_link;
        objectStorySpec.template_data.description =
          newAd.facebookInfo.description;
        objectStorySpec.template_data.call_to_action.type =
          newAd.facebookInfo.callToActionType;
        if (
          objectStorySpec.template_data.image_hash &&
          objectStorySpec.template_data.image_url
        ) {
          objectStorySpec.template_data = _.omit(
            objectStorySpec.template_data,
            ['image_hash']
          );
        }
        if (
          objectStorySpec.template_data.call_to_action &&
          objectStorySpec.template_data.call_to_action.value &&
          objectStorySpec.template_data.call_to_action.value.link
        ) {
          objectStorySpec.template_data.call_to_action.value.link =
            newAd.facebookInfo.ad_link;
          objectStorySpec.template_data.call_to_action.value.link_caption =
            newAd.facebookInfo.linkCaption;
        }
      } else if (objectStorySpec.video_data) {
        objectStorySpec.video_data.title = newAd.facebookInfo.ad_title;
        objectStorySpec.video_data.message = newAd.facebookInfo.ad_body;
        objectStorySpec.video_data.link_description = newAd.facebookInfo
          .description
          ? newAd.facebookInfo.description
          : '';
        objectStorySpec.video_data.call_to_action.type =
          newAd.facebookInfo.callToActionType;
        if (
          objectStorySpec.video_data.call_to_action &&
          objectStorySpec.video_data.call_to_action.value &&
          objectStorySpec.video_data.call_to_action.value.link
        ) {
          objectStorySpec.video_data.call_to_action.value.link =
            newAd.facebookInfo.ad_link;
          objectStorySpec.video_data.call_to_action.value.link_caption =
            newAd.facebookInfo.linkCaption;
        }
        if (
          objectStorySpec.video_data.image_hash &&
          objectStorySpec.video_data.image_url
        ) {
          objectStorySpec.video_data = _.omit(objectStorySpec.video_data, [
            'image_hash'
          ]);
        }
      }
      newAd.creative = { object_story_spec: objectStorySpec };
      newAd.adObjective = objectStorySpec;

      this.props.updatePreview(newAd);
      this.setState({ stateAd: newAd });
    }
  };
  callToActionEnum = [
    'OPEN_LINK',
    'LIKE_PAGE',
    'SHOP_NOW',
    'PLAY_GAME',
    'INSTALL_APP',
    'USE_APP',
    'CALL',
    'CALL_ME',
    'INSTALL_MOBILE_APP',
    'USE_MOBILE_APP',
    'MOBILE_DOWNLOAD',
    'BOOK_TRAVEL',
    'LISTEN_MUSIC',
    'WATCH_VIDEO',
    'LEARN_MORE',
    'SIGN_UP',
    'DOWNLOAD',
    'WATCH_MORE',
    'NO_BUTTON',
    'VISIT_PAGES_FEED',
    'APPLY_NOW',
    'BUY_NOW',
    'GET_OFFER',
    'GET_OFFER_VIEW',
    'BUY_TICKETS',
    'UPDATE_APP',
    'GET_DIRECTIONS',
    'BUY',
    'MESSAGE_PAGE',
    'DONATE',
    'SUBSCRIBE',
    'SAY_THANKS',
    'SELL_NOW',
    'SHARE',
    'DONATE_NOW',
    'GET_QUOTE',
    'CONTACT_US',
    'ORDER_NOW',
    'ADD_TO_CART',
    'VIDEO_ANNOTATION',
    'MOMENTS',
    'RECORD_NOW',
    'GET_SHOWTIMES',
    'LISTEN_NOW',
    'EVENT_RSVP',
    'WHATSAPP_MESSAGE',
    'FOLLOW_NEWS_STORYLINE'
  ];

  updateAssetAdCarousel = (asset, index) => {
    const ad = this.state.stateAd;
    if (asset.type.indexOf('video') !== -1) {
      ad.adObjective.link_data.child_attachments[index].video_id =
        asset.facebook_asset_id;
      ad.adObjective.link_data.child_attachments[index].picture =
        asset.video_thumbnail;
      ad.adObjective.link_data.child_attachments[index] = _.omit(
        ad.adObjective.link_data.child_attachments[index],
        ['image_hash']
      );
    } else {
      let filename = asset.filename;
      const extension = filename.split('.').slice(-1);
      const guid = asset.guid;

      if (guid) {
        filename = `${guid}.${extension}`;
      }

      ad.adObjective.link_data.child_attachments[
        index
      ].picture = `${s3BucketUrl}${filename}`;
      ad.adObjective.link_data.child_attachments[index] = _.omit(
        ad.adObjective.link_data.child_attachments[index],
        ['video_id', 'image_url']
      );
    }
    this.setState({
      stateAd: ad
    });
    this.updateFacebookPreview();
  };
  updateAssetAd = (asset) => {
    const ad = this.state.stateAd;
    if (!ad.isCarousel) {
      if (ad.adObjective && ad.adObjective.link_data) {
        let filename = asset.filename;
        const extension = filename.split('.').slice(-1);
        const guid = asset.guid;

        if (guid) {
          filename = `${guid}.${extension}`;
        }

        ad.adObjective.link_data.picture = `${s3BucketUrl}${filename}`;
        this.setState({
          stateAd: ad
        });
        this.updateFacebookPreview();
      } else if (ad.adObjective && ad.adObjective.video_data) {
        ad.adObjective.video_data.video_id = asset.facebook_asset_id;
        ad.adObjective.video_data.image_url = asset.video_thumbnail;
        this.setState({
          stateAd: ad
        });
        this.updateFacebookPreview();
      }
    }
  };

  renderCallToAction = (callToActionType) => {
    if (callToActionType) {
      return callToActionType.toString().replace('_', ' ');
    }
    return '';
  };
  renderDrawerFacebookButton = (ad) => {
    if (ad.campaignObjective === 'PRODUCT_CATALOG_SALES') {
      return null;
    }
    if (this.state.facebookEdit) {
      return (
        <div>
          <Button
            positive
            onClick={() => {
              this.setState({
                facebookEdit: false,
                editMode: false,
                savingFacebook: true
              });
              this.handleFacebookSave();
              this.props.setEditId('');
            }}
          >
            Save
          </Button>
          <Button
            onClick={() => {
              this.setState({
                facebookEdit: false,
                editMode: false,
                stateAd: this.state.prevStateAd
              });
              this.props.cancellingFacebookAd(this.state.stateAd.ad_id);
              this.props.setEditId('');
            }}
          >
            Cancel
          </Button>
        </div>
      );
    } else if (this.state.savingFacebook) {
      return <Button disabled>Saving Facebook...</Button>;
    }
    return (
      <Button
        onClick={() => {
          this.setState({ facebookEdit: true, editMode: true });
          this.props.setEditId(ad.ad_id);
        }}
      >
        Edit
      </Button>
    );
  };
  renderPopupContent = (content, limit) => {
    if (content) {
      if (content.length > limit) {
        return (
          <Popup
            wide="very"
            trigger={
              <span>
                {content.substring(0, limit)}
                ...
              </span>
            }
            content={<span>{content}</span>}
          />
        );
      }
      return content;
    }
    return null;
  };
  renderPopupContentLink = (content, limit) => {
    if (content) {
      if (content.length > limit) {
        return (
          <Popup
            wide="very"
            trigger={
              <span>
                {content.substring(0, limit)}
                ...
                <a
                  href={content}
                  className="eye-link"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Icon size="large" className="canvas-link" name="eye" />
                </a>
              </span>
            }
            content={<span>{content}</span>}
          />
        );
      }
      return (
        <span>
          {content}
          <a
            href={content}
            className="eye-link"
            rel="noopener noreferrer"
            target="_blank"
          >
            <Icon size="large" className="canvas-link" name="eye" />
          </a>
        </span>
      );
    }
    return null;
  };
  renderCardContent = (child) => (
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <strong>Headline: </strong>
          {child.name}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <strong>Description: </strong>
          {child.description}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <strong>WebLink: </strong>
          {child.link}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <strong>Call To Action: </strong>
          {child.call_to_action ? child.call_to_action.type : ''}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
  renderCardTab = (child, tabIndex) => {
    const index = tabIndex + 1;
    return (
      <Menu.Item key={index}>
        <Popup
          wide="very"
          trigger={<span>Card #{index}</span>}
          content={this.renderCardContent(child)}
        />
      </Menu.Item>
    );
  };
  renderCarouselTabs = (ad, adToCompare) => {
    const adToCompareChild =
      adToCompare &&
      adToCompare.adObjective &&
      adToCompare.adObjective.link_data &&
      adToCompare.adObjective.link_data.child_attachments &&
      adToCompare.adObjective.link_data.child_attachments.length > 0
        ? adToCompare.adObjective.link_data.child_attachments
        : [];
    const tabs = ad.adObjective.link_data.child_attachments.map(
      (child, index) => ({
        menuItem: this.renderCardTab(child, index),
        pane: (
          <Tab.Pane>
            <Grid>
              <Grid.Row
                color={this.compareInfo(
                  child.link,
                  adToCompareChild[index] ? adToCompareChild[index].link : '',
                  this.state.facebookEdit
                )}
              >
                <Grid.Column width={3}>Weblink</Grid.Column>
                <Grid.Column width={9}>
                  {this.state.facebookEdit && !ad.isCanvas ? (
                    <TextArea
                      placeholder="Weblink"
                      defaultValue={child.link}
                      onChange={(event, data) => {
                        this.handleFacebookFieldUpdateCarousel(
                          'link',
                          data.value,
                          index
                        );
                      }}
                      onBlur={() => {
                        this.updateFacebookPreview();
                      }}
                    />
                  ) : (
                    this.renderPopupContentLink(child.link, 70)
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row
                color={this.compareInfo(
                  child.description,
                  adToCompareChild[index]
                    ? adToCompareChild[index].description
                    : '',
                  this.state.facebookEdit
                )}
              >
                <Grid.Column width={3}>Description</Grid.Column>
                <Grid.Column width={9}>
                  {this.state.facebookEdit ? (
                    <TextArea
                      placeholder="Description"
                      defaultValue={child.description}
                      onChange={(event, data) => {
                        this.handleFacebookFieldUpdateCarousel(
                          'description',
                          data.value,
                          index
                        );
                      }}
                      onBlur={() => {
                        this.updateFacebookPreview();
                      }}
                    />
                  ) : (
                    child.description
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row
                color={this.compareInfo(
                  child.name,
                  adToCompareChild[index] ? adToCompareChild[index].name : '',
                  this.state.facebookEdit
                )}
              >
                <Grid.Column width={3}>Headline</Grid.Column>
                <Grid.Column width={9}>
                  {this.state.facebookEdit ? (
                    <TextArea
                      placeholder="Headline"
                      defaultValue={child.name}
                      onChange={(event, data) => {
                        this.handleFacebookFieldUpdateCarousel(
                          'name',
                          data.value,
                          index
                        );
                      }}
                      onBlur={() => {
                        this.updateFacebookPreview();
                      }}
                    />
                  ) : (
                    child.name
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row
                color={this.compareInfo(
                  child && child.call_to_action
                    ? child.call_to_action.type
                    : null,
                  adToCompareChild[index] &&
                    adToCompareChild[index].call_to_action
                    ? adToCompareChild[index].call_to_action.type
                    : '',
                  this.state.facebookEdit
                )}
              >
                <Grid.Column width={3}>Call to Action</Grid.Column>
                <Grid.Column width={9}>
                  {this.state.facebookEdit ? (
                    <Dropdown
                      placeholder="Call to Action"
                      search
                      selection
                      options={this.callToActionEnum.map((o) => ({
                        key: o,
                        value: o,
                        text: o.replace('_', ' ')
                      }))}
                      defaultValue={
                        child && child.call_to_action
                          ? child.call_to_action.type
                          : ''
                      }
                      onChange={(event, data) => {
                        this.handleFacebookFieldUpdateCarousel(
                          'call_to_action',
                          data.value,
                          index
                        );
                      }}
                      onBlur={() => {
                        this.updateFacebookPreview();
                      }}
                    />
                  ) : (
                    this.renderCallToAction(
                      child && child.call_to_action
                        ? child.call_to_action.type
                        : ''
                    )
                  )}
                </Grid.Column>
              </Grid.Row>
              {this.state.facebookEdit ? (
                <Grid.Row>
                  <Grid.Column width={9}>
                    <AssetGallery
                      allowFilterType
                      previewFileUrl={this.getAssetCarouselPreview(child)}
                      getFbToken={this.props.getFbToken}
                      onAssetSelected={(assetSelected) => {
                        this.updateAssetAdCarousel(assetSelected, index);
                      }}
                    />
                  </Grid.Column>
                </Grid.Row>
              ) : null}
            </Grid>
          </Tab.Pane>
        )
      })
    );
    return <Tab renderActiveOnly={false} panes={tabs} />;
  };

  renderBoolText = (fieldValue) => (fieldValue ? 'Yes' : 'No');

  render() {
    const adToCompare = this.props.adToCompare
      ? this.props.adToCompare
      : { lineageInfo: {}, facebookInfo: {} };
    const ad = this.state.stateAd;
    const facebookInfo = ad.facebookInfo;
    // facebookInfo.audienceArray.targetingsentencelines.targetingsentencelines
    if (
      adToCompare.lineageInfo === undefined ||
      adToCompare.lineageInfo === null
    ) {
      adToCompare.lineageInfo = {};
    }
    return (
      <div>
        <Accordion styled>
          <Accordion.Title
            active={this.props.moreInfoIndex[this.props.parentAdId] === 8}
            onClick={() => {
              this.handleAccordionClick(8);
            }}
          >
            <Icon name="dropdown" />
            Metrics
          </Accordion.Title>
          <Accordion.Content
            active={this.props.moreInfoIndex[this.props.parentAdId] === 8}
            className="ad-comparer-more-info"
          >
            <Grid divided="vertically">
              <Grid.Row>
                <Grid.Column width={2}>CTR</Grid.Column>
                <Grid.Column width={4}>
                  {ad.metrics && ad.metrics.ctr ? ad.metrics.ctr : 'N/A'}
                </Grid.Column>
                <Grid.Column width={2}>CPC</Grid.Column>
                <Grid.Column width={4}>
                  {ad.metrics && ad.metrics.cpc ? ad.metrics.cpc : 'N/A'}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={2}>Reach</Grid.Column>
                <Grid.Column width={3}>
                  {ad.metrics && ad.metrics.reach ? ad.metrics.reach : 'N/A'}
                </Grid.Column>
                <Grid.Column width={3}>Impressions</Grid.Column>
                <Grid.Column width={3}>
                  {ad.metrics && ad.metrics.impressions
                    ? ad.metrics.impressions
                    : 'N/A'}
                </Grid.Column>
                <Grid.Column width={3}>Link Clicks</Grid.Column>
                <Grid.Column width={2}>
                  {ad.metrics && ad.metrics.clicks ? ad.metrics.clicks : 'N/A'}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
          <Accordion.Title
            active={this.props.moreInfoIndex[this.props.parentAdId] === 0}
            onClick={() => {
              this.handleAccordionClick(0);
            }}
          >
            <Icon name="dropdown" />
            Facebook Parameters
          </Accordion.Title>
          <Accordion.Content
            active={this.props.moreInfoIndex[this.props.parentAdId] === 0}
            className="ad-comparer-more-info"
          >
            <Grid divided="vertically">
              <Grid.Row>
                <Grid.Column>{this.renderDrawerFacebookButton(ad)}</Grid.Column>
              </Grid.Row>
              {ad.isCarousel ? (
                this.renderCarouselTabs(ad, adToCompare)
              ) : (
                <div style={{ width: '100%' }}>
                  <Grid.Row
                    color={this.compareInfo(
                      facebookInfo.ad_link,
                      adToCompare.facebookInfo.ad_link,
                      this.state.facebookEdit
                    )}
                  >
                    <Grid.Column width={3}>Weblink</Grid.Column>
                    <Grid.Column width={9}>
                      {this.state.facebookEdit && !ad.isCanvas ? (
                        <TextArea
                          placeholder="Weblink"
                          defaultValue={facebookInfo.ad_link}
                          onChange={(event, data) => {
                            this.handleFacebookFieldUpdate(
                              'ad_link',
                              data.value
                            );
                          }}
                          onBlur={() => {
                            this.updateFacebookPreview();
                          }}
                        />
                      ) : (
                        this.renderPopupContentLink(facebookInfo.ad_link, 70)
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row
                    color={this.compareInfo(
                      facebookInfo.linkCaption,
                      adToCompare.facebookInfo.linkCaption,
                      this.state.facebookEdit
                    )}
                  >
                    <Grid.Column width={3}>Display Link</Grid.Column>
                    <Grid.Column width={9}>
                      {this.state.facebookEdit && !ad.isCanvas ? (
                        <TextArea
                          placeholder="Display Link"
                          defaultValue={facebookInfo.linkCaption}
                          onChange={(event, data) => {
                            this.handleFacebookFieldUpdate(
                              'linkCaption',
                              data.value
                            );
                          }}
                          onBlur={() => {
                            this.updateFacebookPreview();
                          }}
                        />
                      ) : (
                        facebookInfo.linkCaption
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row
                    color={this.compareInfo(
                      facebookInfo.ad_title,
                      adToCompare.facebookInfo.ad_title,
                      this.state.facebookEdit
                    )}
                  >
                    <Grid.Column width={3}>Headline</Grid.Column>
                    <Grid.Column width={9}>
                      {this.state.facebookEdit ? (
                        <TextArea
                          placeholder="Headline"
                          defaultValue={facebookInfo.ad_title}
                          onChange={(event, data) => {
                            this.handleFacebookFieldUpdate(
                              'ad_title',
                              data.value
                            );
                          }}
                          onBlur={() => {
                            this.updateFacebookPreview();
                          }}
                        />
                      ) : (
                        facebookInfo.ad_title
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row
                    color={this.compareInfo(
                      facebookInfo.description,
                      adToCompare.facebookInfo.description,
                      this.state.facebookEdit
                    )}
                  >
                    <Grid.Column width={3}>Description</Grid.Column>
                    <Grid.Column width={9}>
                      {this.state.facebookEdit ? (
                        <TextArea
                          placeholder="Description"
                          defaultValue={facebookInfo.description}
                          onChange={(event, data) => {
                            this.handleFacebookFieldUpdate(
                              'description',
                              data.value
                            );
                          }}
                          onBlur={() => {
                            this.updateFacebookPreview();
                          }}
                        />
                      ) : (
                        facebookInfo.description
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row
                    color={this.compareInfo(
                      facebookInfo.callToActionType,
                      adToCompare.facebookInfo.callToActionType,
                      this.state.facebookEdit
                    )}
                  >
                    <Grid.Column width={3}>Call to Action</Grid.Column>
                    <Grid.Column width={9}>
                      {this.state.facebookEdit ? (
                        <Dropdown
                          placeholder="Call to Action"
                          search
                          selection
                          options={this.callToActionEnum.map((o) => ({
                            key: o,
                            value: o,
                            text: o.replace('_', ' ')
                          }))}
                          defaultValue={facebookInfo.callToActionType}
                          onChange={(event, data) => {
                            this.handleFacebookFieldUpdate(
                              'callToActionType',
                              data.value
                            );
                          }}
                          onBlur={() => {
                            this.updateFacebookPreview();
                          }}
                        />
                      ) : (
                        this.renderCallToAction(facebookInfo.callToActionType)
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  {this.state.facebookEdit ? (
                    <Grid.Row>
                      <Grid.Column width={9}>
                        <AssetGallery
                          previewFileUrl={this.getAssetPreview(ad.adObjective)}
                          assetType={this.getAssetType(ad.adObjective)}
                          getFbToken={this.props.getFbToken}
                          onAssetSelected={(assetSelected) => {
                            this.updateAssetAd(assetSelected, ad);
                          }}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  ) : null}
                </div>
              )}
              <Grid.Row>
                <Grid.Column>
                  <div>
                    Start Date: <strong>{ad.start_time}</strong>
                  </div>
                  <div>
                    End Date: <strong>{ad.end_time}</strong>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row
                color={this.compareInfo(
                  facebookInfo.ad_body,
                  adToCompare.facebookInfo.ad_body,
                  this.state.facebookEdit
                )}
              >
                <Grid.Column width={3}>Copy</Grid.Column>
                <Grid.Column width={9}>
                  {this.state.facebookEdit ? (
                    <TextArea
                      placeholder="Copy"
                      defaultValue={facebookInfo.ad_body}
                      onChange={(event, data) => {
                        this.handleFacebookFieldUpdate('ad_body', data.value);
                      }}
                      onBlur={() => {
                        this.updateFacebookPreview();
                      }}
                    />
                  ) : (
                    facebookInfo.ad_body
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row
                color={this.compareInfo(
                  ad.url_tags,
                  adToCompare.url_tags,
                  this.state.facebookEdit
                )}
              >
                <Grid.Column width={16}>UTM</Grid.Column>
                <Grid.Column width={16}>
                  {this.state.facebookEdit ? (
                    <TextArea
                      placeholder="UTM"
                      defaultValue={ad.url_tags}
                      onChange={(event, data) => {
                        this.handleAdFieldUpdate('url_tags', data.value);
                      }}
                    />
                  ) : (
                    this.renderPopupContent(ad.url_tags, 70)
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row
                color={this.compareInfo(
                  facebookInfo.audience,
                  adToCompare.facebookInfo.audience,
                  this.state.facebookEdit
                )}
              >
                <Grid.Column width={16}>Audience</Grid.Column>
                <Grid.Column width={16}>
                  {facebookInfo.audienceArray.targetingsentencelines.targetingsentencelines.map(
                    (target) => (
                      <p key={shortid.generate()}>
                        {`${target.content} ${target.children[0]}`}
                      </p>
                    )
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={3}>Creative Id</Grid.Column>
                <Grid.Column width={9}>{facebookInfo.creativeId}</Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
          <Accordion.Title
            active={this.props.moreInfoIndex[this.props.parentAdId] === 5}
            onClick={() => {
              this.handleAccordionClick(5);
            }}
          >
            <Grid>
              <Grid.Row>
                <Grid.Column width={12}>
                  <Icon name="dropdown" />
                  Notes - QC
                </Grid.Column>
                <Grid.Column width={4}>
                  {renderPopupQCOrCheckbox(this.props.ad, 'qc1')}
                  {renderPopupQCOrCheckbox(this.props.ad, 'qc2')}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Title>
          <Accordion.Content
            active={this.props.moreInfoIndex[this.props.parentAdId] === 5}
            className="ad-comparer-more-info"
          >
            <AdNotesQC
              tabName={this.props.tabName}
              updateParentState={this.props.updateCompareAd}
              adPreview={this.props.ad}
              adSection={this.props.adSection}
              getFbToken={this.props.getFbToken}
              generateCopyLink={this.props.generateCopyLink}
              adAccountName={this.props.adAccountName}
            />
          </Accordion.Content>
        </Accordion>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  moreInfoIndex: state.adPreview.moreInfoIndex
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdMoreInfo);



// WEBPACK FOOTER //
// ./src/screens/Flipper/ParentSection/AdMoreInfo.js